export default function GomokuIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <path d="M6 8h52M6 20h52M6 32h52M6 44h52M6 56h52M8 6v52M20 6v52M32 6v52M44 6v52M56 6v52" stroke="#3B434F" strokeWidth="2.5" />
      <circle cx="20" cy="20" r="5.5" fill="#FF8A1F" />
      <circle cx="44" cy="44" r="5.5" fill="#FF8A1F" />
      <circle cx="56" cy="32" r="5.5" fill="#FF8A1F" />
      {[0, 1, 2, 3, 4].map((i) => (
        <circle key={i} cx={8 + i * 12} cy={56 - i * 12} r="5.5" fill="#2F8BFF" />
      ))}
      <path d="M8 56L56 8" stroke="#E7ECF3" strokeWidth="2" strokeLinecap="round" opacity="0.8" />
    </svg>
  );
}
